module.exports = __webpack_public_path__ + "img/Tessellate23.7e8dc79d.jpg";